import { render, staticRenderFns } from "./SrmSourcing.vue?vue&type=template&id=f01715da&scoped=true"
import script from "./SrmSourcing.vue?vue&type=script&lang=js"
export * from "./SrmSourcing.vue?vue&type=script&lang=js"
import style0 from "./SrmSourcing.vue?vue&type=style&index=0&id=f01715da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01715da",
  null
  
)

export default component.exports